export default function TermsSection() {

  return (
    <section className="pb-16 bg-white min-h-screen">
      <div className="max-w-6xl mx-auto px-8 sm:px-8 lg:px-0 mt-[30px]">

        <h1 className="text-4xl font-bold text-[#00889D] mb-6">
          Yoga Seven Terms & Conditions Policy
        </h1>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          <strong>Yoga Seven – Hot Yoga & Fitness Studio</strong><br />
          Effective Date: December 20, 2025
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          These Terms & Conditions (“Terms”) govern your access to and use of www.yogaseven.com, our booking and customer management systems (including Mariana Trek), and your participation in any class, programs, workshops, events, or services offered by Yoga Seven – Hot Yoga & Fitness Studio (“Yoga Seven,” “Yoga 7,” “we,” “us,” or “our”).
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          By accessing our website, creating an account, booking a class, purchasing a membership, or attending a session, you agree to these Terms.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          1. Participation & Health Disclaimer / Workout Safely
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga, fitness, and heated or infrared exercise involve physical exertion and inherent risks.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven strongly recommends that all clients consult with a physician or qualified healthcare professional before beginning any exercise program, including yoga, fitness, and heated or infrared class offered at Yoga Seven.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          By participating in any Yoga Seven services, you confirm and acknowledge that:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>You are physically fit and able to safely participate in yoga and fitness activities.</li>
          <li>You have consulted a medical professional if you have any medical conditions, injuries, cardiovascular concerns, or if you are pregnant.</li>
          <li>Pregnant participants may attend classes only with prior medical clearance and must inform the instructor before class.</li>
          <li>You understand and accept the risks associated with both heated and non-heated classes, including but not limited to muscle strain, dehydration, dizziness, overheating, or other physical injury.</li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven is not a medical care provider and does not provide medical advice, diagnosis, or treatment of any kind, nor does it determine the effect of any specific exercise on individual medical conditions.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Participation is voluntary and at your own risk. By participating, you assume full responsibility for your health and safety.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          2. Assumption of Risk & Limitation of Liability
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          To the fullest extent permitted by law, you acknowledge and accept all risks associated with participation in Yoga Seven classes and activities.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven, its owners, instructors, employees, contractors, and affiliates are not responsible for any injury, illness, loss, or damage arising from participation in our services, except where liability cannot be excluded by law.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          This includes, but is not limited to:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Physical injury or illness</li>
          <li>Dehydration, overheating, or dizziness</li>
          <li>Loss or damage to personal property</li>
        </ul>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          3. Class Bookings, Cancellations & No-Shows
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Class reservations may be required and are subject to availability.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Bookings and cancellations are managed through our booking system (Mariana Trek).
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Cancellation & No-Show Fees
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">

          <li>
            Late Cancellation Fee: $10
            <p>Applies to classes cancelled less than 4 hours before the scheduled class start time.</p>
          </li>

          <li>
            No-Show Fee: $20
            <p>Applies if you do not attend a booked class and do not cancel in advance.</p>
          </li>

          <li>
            Cancellations made outside the late-cancellation window will not incur a fee.
          </li>

        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Late arrivals may not be permitted to join class for safety and class flow reasons.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven reserves the right to cancel or reschedule classes when necessary.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          4. Class Booking Rules
        </h2>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>
            Members may book a maximum of two (2) classes per day.
          </li>

          <li>
            Back-to-back bookings are discouraged.
          </li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          If you book back-to-back classes and do not attend one of them for any reason, the applicable late cancellation ($10) or no-show fee ($20) will apply.
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">

          <li>
            Members are encouraged to make responsible booking choices to ensure fair access for all.
          </li>

          <li>
            If you wish to attend back-to-back classes, we recommend:
          </li>

        </ul>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Booking your preferred class first, and</li>
          <li>Checking with the front desk for availability in a second class closer to the start time.</li>
        </ul>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>
            Overlapping classes are not permitted.
          </li>

          <p className="text-base text-gray-600 mb-6 leading-relaxed">
            Please book only the class you intend to attend.
          </p>

          <li>
            If you are booked into two classes at the same time, you will be charged the applicable fee for the class you do not attend.
          </li>
        </ul>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          5. Memberships, Auto-Pay & Payments
        </h2>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>
            Memberships, class packages, and promotional offers are subject to specific terms at the time of purchase.
          </li>

          <li>
            All memberships and packages are non-transferable and non-refundable, unless required by law.
          </li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed font-bold">
          Auto-Pay Memberships
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>
            Auto-pay memberships require one (1) full month notice to cancel.
          </li>

          <li>
            Auto-pay cancellations must be completed in person at the studio.
          </li>

          <li>
            Memberships remain active and billable during the notice period.
          </li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven reserves the right to update pricing, schedules, instructors, and class formats at any time.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          6. Refunds & Account Credits
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          All purchases are final.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          No refunds are provided for unused classes, late cancellations, or no-shows.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Account credits, if offered, are granted at the sole discretion of Yoga Seven.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          7. Studio Conduct & Etiquette
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Clients are expected to:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Arrive on time and follow studio guidelines</li>
          <li>Respect instructors, staff, and fellow clients</li>
          <li>Follow all safety instructions, especially in heated classes</li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven reserves the right to refuse service or suspend access to services for unsafe, disruptive, or inappropriate behaviour.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          8. Cell Phones
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          To maintain a respectful and focused environment:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Cell phones must be silenced and screens darkened during classes.</li>
          <li>Texting, phone calls, and device use during class are not permitted.</li>
          <li>Between classes, photos or videos may be taken for personal or promotional use only with the consent of others and with respect for privacy.</li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven reserves the right to implement a no-cell-phone policy in studio areas at its discretion.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          9. Dress Code
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Appropriate athletic clothing must be worn during classes. Yoga Seven reserves the right to determine appropriate attire for safety, comfort, and hygiene. If you have questions regarding appropriate attire, please contact the studio in advance.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          10. Child Safety & Childminding
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven does not offer childminding services.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Children may not be left unattended in the studio and may not accompany members into classes unless attending a specific child-inclusive workshop or event.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          11. Waitlists
        </h2>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>
            Joining a waitlist should be treated as a confirmed reservation. Be prepared to attend if a spot becomes available.
          </li>

          <li>
            If you are unable to attend, you are responsible for removing yourself from the waitlist before being added to the class.
          </li>

          <li>
            Late cancellation and no-show fees apply once you are moved from the waitlist into a class.
          </li>

          <li>
            Please ensure your app notifications are enabled to receive timely updates.
          </li>
        </ul>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          12. Check-In & Late Arrival Policy
        </h2>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Please arrive at least 15 minutes early for class.</li>
          <li>There is no entry to classes already in session.</li>
          <li>If you are not checked in 5 minutes prior to class start, your spot may be released to a waitlisted client.</li>
        </ul>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          13. Heated Classes & Back-to-Back Limits
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          For safety reasons:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>
            Members may not attend more than 90 consecutive minutes of heated fitness classes.
          </li>

          <li>
            Restrictions on consecutive heated classes are enforced for member safety and may vary by class type.
          </li>
        </ul>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          14. Minors
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Individuals under the age of 16 may participate only with written consent from a parent or legal guardian and only in approved programs or classes.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Minors are not permitted in heated or infrared classes unless explicitly approved.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          15. Personal Belongings
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven is not responsible for lost, stolen, or damaged personal belongings. Storage areas are provided for convenience only.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          16. Newsletters & Emails
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          By creating an account or signing waivers, you may receive transactional emails, reminders, and occasional newsletters. You may unsubscribe from marketing communications at any time using the unsubscribe link or by contacting us directly.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          17. Website Use & Intellectual Property
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          All content on www.yogaseven.com, including logos, branding, images, text, and materials, is the property of Yoga Seven and protected by applicable copyright and trademark laws.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          You may not copy, reproduce, modify, or distribute website content without written permission.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          18. Privacy
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Your use of our services is subject to our Privacy Policy, which forms part of these Terms & Conditions.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          19. Force Majeure
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven is not responsible for service interruptions caused by events beyond our reasonable control, including weather conditions, power outages, government restrictions, or emergencies.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          20. Changes to These Terms
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven reserves the right to update or modify these Terms at any time.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Changes will be posted on our website with an updated effective date. Continued use of services constitutes acceptance of the revised Terms.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          21. Governing Law
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          These Terms & Conditions are governed by the laws of British Columbia, Canada.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          22. Contact Information
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven – Hot Yoga & Fitness Studio<br />
          Langley, British Columbia, Canada<br />
          📧 Email: info@yogaseven.com<br />
          🌐 Website: www.yogaseven.com
        </p>

      </div>
    </section>
  );
}